import { Download, X } from 'lucide-react'
import { usePwaInstall } from '@/hooks/usePwaInstall'
import { Button } from '@/components/ui/button'

export function PwaInstallBanner() {
  const { canInstall, install, dismiss } = usePwaInstall()

  if (!canInstall) return null

  return (
    <div className="fixed bottom-4 left-1/2 z-50 flex w-[calc(100%-2rem)] max-w-md -translate-x-1/2 items-center gap-3 rounded-xl border border-gray-200 bg-white px-4 py-3 shadow-lg">
      <div className="flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-lg">
        <img src="/pwa-192x192.png" alt="PuroViento" className="h-full w-full object-contain" />
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold text-gray-900">Instalar PuroViento</p>
        <p className="text-xs text-gray-500">Acceso rápido desde tu pantalla de inicio</p>
      </div>
      <Button
        size="sm"
        className="shrink-0 bg-[#dff24b] text-gray-900 hover:bg-[#cce03a]"
        onClick={install}
      >
        <Download className="mr-1.5 h-3.5 w-3.5" />
        Instalar
      </Button>
      <button
        type="button"
        onClick={dismiss}
        className="shrink-0 rounded-md p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600"
        aria-label="Cerrar"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  )
}
